module.exports = __webpack_public_path__ + "media/images/e-bilet/train_separation-2ddf106ea9b64a38c1d3b4d02fce0446.svg";